const API_HOST = process.env.REACT_APP_API_HOST_URL;

const exportProductSummaryByBranch = async ({ ...parameters }) => {
  // Return a promise that resolves when export is complete
  return new Promise((resolve, reject) => {
    try {
      openWindowWithPost(
        `${API_HOST}/distributor/export/v1/inventory/productSummaryByBranch?&token=${parameters.token}`,
        JSON.stringify({
          data: parameters.data,
        }),
        resolve // Pass the resolve function to complete the promise
      );
    } catch (error) {
      reject(error);
    }
  });
};

function openWindowWithPost(url, data, onComplete) {
  // Create a hidden iframe to handle the download without opening a new tab
  const iframe = document.createElement('iframe');
  iframe.style.display = 'none';
  document.body.appendChild(iframe);

  // Create a form inside the iframe
  const iframeDoc = iframe.contentDocument || iframe.contentWindow.document;
  const form = iframeDoc.createElement("form");
  form.method = "POST";
  form.action = url;
  form.style.display = "none";

  const input = iframeDoc.createElement("input");
  input.type = "hidden";
  input.name = 'data';
  input.value = data;
  form.appendChild(input);

  iframeDoc.body.appendChild(form);

  // Set up onload handler to remove the iframe after download starts
  iframe.onload = () => {
    setTimeout(() => {
      document.body.removeChild(iframe);
      // Resolve the promise after iframe is removed
      if (onComplete) onComplete();
    }, 1000); // Add a small delay to ensure the download starts
  };

  form.submit();
}

export default exportProductSummaryByBranch;
